import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';

/** Seconds before the event end within which a lecture start triggers a collision warning. */
export const EVENT_END_WARNING_RADIUS = 60 * 60;

export function useEventTimeRange() {
    const timeStart = useSelector((state: RootState) => state.event.timeStart);
    const timeEnd = useSelector((state: RootState) => state.event.timeEnd);

    const isWithin = useCallback((time: number): boolean => {
        if(timeStart == null || timeEnd == null) return true;
        return time >= timeStart && time <= timeEnd;
    }, [timeStart, timeEnd]);

    const isCloseToEnd = useCallback((time: number): boolean => {
        if(timeEnd == null) return false;
        return time <= timeEnd && timeEnd - time < EVENT_END_WARNING_RADIUS;
    }, [timeEnd]);

    return {isWithin, isCloseToEnd};
}
